module.exports = __webpack_public_path__ + "img/profile.3dab3b17.jpg";